export default __webpack_public_path__ + "static/media/050-power supply.c3a0650e.svg";